import React from 'react';
import { InstallationRequestForm } from '../components/InstallationRequestForm';

const InstallationRequestPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              درخواست نصب سیستم خورشیدی
            </h1>
            <p className="text-gray-600">
              اطلاعات مکان و نیاز خود را وارد کنید تا بهترین نصاب‌ها پیشنهاد خود را ارسال کنند
            </p>
          </div>
          
          <InstallationRequestForm />
        </div>
      </div>
    </div>
  );
};

export default InstallationRequestPage;